<template>
    <div class="center-on-page">
        <div class="logo-form-con">

            <router-link :to="{ name : $ROUTES.LOGIN }">
                <div class="has-text-centered">
                    <div class="image logo" v-if="this.$store.state.dealer_portal.brandLogo">
                        <img :src="$srcOverwrite(this.$store.state.dealer_portal.brandLogo)"/>
                    </div>
                    <h1 class="title">{{this.$store.state.dealer_portal.brandName}} Password Reset</h1>
                </div>
            </router-link>

            <div v-if="loading_check" class="center-on-page">
                <i class="fa fa-spinner fa-spin fa-fw" style="font-size:3em;"></i>
            </div>

            <div v-if="token_expired" class="notification is-warning">
                Your password reset token has expired! Redirecting you to the login page in {{redirect_time}}
            </div>

            <div v-if="success" class="notification is-success">
                Your passsword has been reset! Please <router-link :to="{name : $ROUTES.LOGIN }">login</router-link> with your new password.
            </div>

            <form @submit.prevent="resetPassword('reset')" data-vv-scope="reset" v-if="!token_expired && !loading_check && !success">

                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('reset.password') }" type="password" placeholder="New Password" v-model="password" name="password" v-validate="'required'" ref="password"/>
                        <span class="icon is-left">
                            <i class="fa fa-dealer-secret"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('reset.password')" class="help is-danger">{{ errors.first('reset.password') }}</p>
                </div>

                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('reset.password_confirm') }" type="password" placeholder="Confirm Password" v-model="password_confirm" name="password_confirm" v-validate="'required|confirmed:password'"/>
                        <span class="icon is-left">
                            <i class="fa fa-dealer-secret"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('reset.password_confirm')" class="help is-danger">{{ errors.first('reset.password_confirm') }}</p>
                </div>

                <button class="button is-primary is-block-button" :class="{ 'is-loading' : loading }" type="submit">
                    Reset
                </button>

            </form>

        </div>

    </div>
</template>

<script>
import UserPublic from '@/api/UserPublic'
export default {
    name : 'reset-password',
    data () {
        return {
            password : '',
            password_confirm : '',
            loading_check : true,
            loading : false,
            token_expired : false,
            redirect_time : 10,
            success : false,
        }
    },
    beforeCreate () {
        if (this.$store.state.dealer && this.$store.state.dealer.id) {
            this.$router.push({ name : 'dashboard' })
        }
        UserPublic.getValidatePasswordResetToken(this.$route.params.user_id, this.$route.params.token).then((response) => {
            if (response.data.expired) {
                this.token_expired = true
                let interval = setInterval(() => {
                    this.redirect_time--
                    if (this.redirect_time <= 0 && interval) {
                        clearInterval(interval)
                        this.$router.push({ name : 'login' })
                    }
                }, 1000)
            } else if (!response.data.valid) {
                this.$router.push({ name : 'login' })
            }
            this.loading_check = false
        })
    },
    methods : {
        resetPassword (scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (!result) {
                    return
                }
                this.loading = true
                UserPublic.postPasswordReset(this.$route.params.user_id, this.$route.params.token, { password : this.password }).then(() => {
                    this.success = true
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .logo {
        margin-bottom:20px;
        img {
            max-height: 80px;
            max-width: 100%;
            width: auto;
            height: auto;
            margin:0 auto;
        }
    }
    .title {
        margin-bottom:20px;
    }
</style>
